<template>
  <div class="tab-content">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item>
            <el-button class="el-btn-blue" size="mini" icon="el-icon-plus" @click="addMyProducts()" style="margin-bottom: 10px;">Add products inside my brand</el-button>
            <div class="main-table">
              <el-table :data="products" border size="small" :header-cell-style="headerStyle" :cell-style="cellStyle">
                <el-table-column label="Products from my brands">
                  <el-table-column label="Price">
                    <template #default="scope">
                      {{ `${scope.row.price.default.symbol}${scope.row.price.default.price}` }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="general.name" label="Name"></el-table-column>
                  <el-table-column label="Show in Product Library">
                    <template #default="scope">
                      <el-switch v-model="scope.row.is_active" active-color="#A5C2CB" />
                    </template>
                  </el-table-column>
                  <el-table-column label="Feature in Player Slots 1-3">
                    <template #default="scope">
                      <el-select
                        class="content" v-model="scope.row.order" style="width: 80px;" placeholder=" "
                        @change="((val) => {selectOrder(val, scope.row._id)})"
                      >
                        <el-option key="0" label="" value=""></el-option>
                        <el-option key="1" label="1" :value="1"></el-option>
                        <el-option key="2" label="2" :value="2"></el-option>
                        <el-option key="3" label="3" :value="3"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
            <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item>
            <el-button class="el-btn-blue" size="mini" icon="el-icon-plus" @click="addOtherProducts()" style="margin-bottom: 10px;">Add products outside my brand</el-button>
            <div class="main-table">
              <el-table :data="otherProducts" border size="small" :header-cell-style="headerStyle" :cell-style="cellStyle">
                <el-table-column>
                  <el-table-column label="Price">
                    <template #default="scope">
                      {{ `${scope.row.price.default.symbol}${scope.row.price.default.price}` }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="general.name" label="Name"></el-table-column>
                  <el-table-column label="Show in Product Library">
                    <template #default="scope">
                      <el-switch v-model="scope.row.is_active" active-color="#A5C2CB" />
                    </template>
                  </el-table-column>
                  <el-table-column label="Feature in Player Slots 1-3">
                    <template #default="scope">
                      <el-select
                        class="content" v-model="scope.row.order" style="width: 80px;" placeholder=" "
                        @change="((val) => {selectOrder(val, scope.row._id)})"
                      >
                        <el-option key="0" label="" value=""></el-option>
                        <el-option key="1" label="1" :value="1"></el-option>
                        <el-option key="2" label="2" :value="2"></el-option>
                        <el-option key="3" label="3" :value="3"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <template #header>
                    <div class="header">
                      <div>Products from other brands</div>
                      <div class="supportButton" @click="addProductsGuide">?</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 样式修改 -->
      <!-- <div class="products-container">
        <div class="products-item">
          <div class="product-header">
            <div class="header-info">
              <div class="info-left" @click="toggleSelectMyBrand()">
                <div class="info-icon">
                  <el-icon v-show="!flagToggleMyBrand"><arrow-down-bold /></el-icon>
                  <el-icon v-show="flagToggleMyBrand"><arrow-up-bold /></el-icon>
                </div>
                <div class="info-title">
                  <span class="title-song">Products from my brand</span>
                </div>
              </div>
              <div class="info-right">
                <div class="info-switch">
                </div>
                <div class="info-support">
                </div>
              </div>
            </div>
            <div class="header-titles">
              <div class="title-item item-price">
                <span>Price</span>
              </div>
              <div class="title-item item-name">
                <span>Name</span>
              </div>
              <div class="title-item item-active">
                <span>Show in Product Library</span>
              </div>
              <div class="title-item item-order">
                <span>Feature in Player Slots 1-3</span>
              </div>
            </div>
          </div>
          <div class="product-content" v-show="flagToggleMyBrand">
            <div class="product-list">
              <div class="addProductsButton">
                <el-button class="el-btn-blue" type="text" size="mini" icon="el-icon-plus" @click="addMyProducts()" style="margin-bottom: 10px;">Add products inside my brand</el-button>
              </div>
              <div class="product-item" v-for="(product, productIndex) in products"  :key="product._id">
                <div class="item-text text-price">
                  <span>{{ product.price.default.symbol + product.price.default.price }}</span>
                </div>
                <div class="item-text text-name">
                  <span>{{ product.general.name }}</span>
                </div>
                <div class="item-text text-active">
                  <div
                    :class="['ca-checkbox', product.is_active ? 'active': 'inactive']"
                    @click="toggleProductActive(productIndex)"
                  ></div>
                </div>
                <div class="item-text text-order">
                  <el-select
                    class="content" v-model="product.order" style="width: 80px;" placeholder=" "
                    @change="((val) => {selectOrder(val, product._id)})"
                  >
                    <el-option key="0" label="" value=""></el-option>
                    <el-option key="1" label="1" :value="1"></el-option>
                    <el-option key="2" label="2" :value="2"></el-option>
                    <el-option key="3" label="3" :value="3"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="products-item">
          <div class="product-header">
            <div class="header-info">
              <div class="info-left" @click="toggleSelectOtherBrand()">
                <div class="info-icon">
                  <el-icon v-show="!flagToggleOtherBrands"><arrow-down-bold /></el-icon>
                  <el-icon v-show="flagToggleOtherBrands"><arrow-up-bold /></el-icon>
                </div>
                <div class="info-title">
                  <span class="title-song">Products from other brands</span>
                </div>
              </div>
              <div class="info-right">
                <div class="info-switch">
                </div>
                <div class="info-support">
                  <el-button size="small" type="text" class="el-btn-blue" @click="addProductsGuide"><div class="supportButton">?</div></el-button>
                </div>
              </div>
            </div>
            <div class="header-titles">
              <div class="title-item item-price">
                <span>Price</span>
              </div>
              <div class="title-item item-name">
                <span>Name</span>
              </div>
              <div class="title-item item-active">
                <span>Show in Product Library</span>
              </div>
              <div class="title-item item-order">
                <span>Feature in Player Slots 1-3</span>
              </div>
            </div>
          </div>
          <div class="product-content" v-show="flagToggleOtherBrands">
            <div class="product-list">
              <div class="addProductsButton">
                <el-button class="el-btn-blue" type="text" size="mini" icon="el-icon-plus" @click="addOtherProducts()" style="margin-bottom: 10px;">Add products outside my brand</el-button>
              </div>
              <div class="product-item" v-for="(otherProduct, otherProductIndex) in otherProducts"  :key="otherProduct._id">
                <div class="item-text text-price">
                  <span>{{ otherProduct.price.default.symbol + otherProduct.price.default.price }}</span>
                </div>
                <div class="item-text text-name">
                  <span>{{ otherProduct.general.name }}</span>
                </div>
                <div class="item-text text-active">
                  <div
                    :class="['ca-checkbox', otherProduct.is_active ? 'active': 'inactive']"
                    @click="toggleOtherProductActive(otherProductIndex)"
                  ></div>
                </div>
                <div class="item-text text-order">
                  <el-select
                    class="content" v-model="otherProduct.order" style="width: 80px;" placeholder=" "
                    @change="((val) => {selectOrder(val, otherProduct._id)})"
                  >
                    <el-option key="0" label="" value=""></el-option>
                    <el-option key="1" label="1" :value="1"></el-option>
                    <el-option key="2" label="2" :value="2"></el-option>
                    <el-option key="3" label="3" :value="3"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 样式修改 -->
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updateInstance" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <ModalProducts
      :flagVisible="flagVisible.modalProducts" @closeModal="flagVisible.modalProducts = false"
      :role="role" :addFromWhere="addFromWhere" @changeProducts="changeProducts($event)"
      :brandId="instance.general.brand_id"
    />
    <PermissionProducts
      :flagVisible="flagVisible.permissionProducts" @closeModal="flagVisible.permissionProducts = false"
    />
    <PermissionAddProducts
      :flagVisible="flagVisible.PermissionAddProducts" @closeModal="flagVisible.PermissionAddProducts = false"
    />
    <PermissionOtherProducts
      :flagVisible="flagVisible.permissionOtherProducts" @closeModal="flagVisible.permissionOtherProducts = false"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import ModalProducts from './ModalProducts.vue'
// import { ArrowUpBold, ArrowDownBold } from '@element-plus/icons'
import _ from 'lodash'
import PermissionProducts from '@/components/instances/permissions/Products.vue'
import PermissionOtherProducts from '@/components/instances/permissions/OtherProducts.vue'
import PermissionAddProducts from '@/components/instances/permissions/AddProducts.vue'
export default {
  name: 'TabProducts',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
    // ArrowUpBold,
    // ArrowDownBold,
    ModalProducts,
    PermissionProducts,
    PermissionAddProducts,
    PermissionOtherProducts
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
      modalProducts: false,
      permissionProducts: false,
      PermissionAddProducts: false,
      permissionOtherProducts: false
    })
    const actionItems = reactive({
    })
    return {
      instance: { general: {} },
      features: {},
      products: [],
      otherProducts: [],
      addFromWhere: '',
      flagToggleMyBrand: false,
      flagToggleOtherBrands: false,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.products) this.products = [...val.products]
          if (val && val.other_products) this.otherProducts = [...val.other_products]
          if (val && val.features) this.features = { ...val.features }
        }
      },
      deep: true
    }
  },
  methods: {
    updateInstance: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      const products = []
      const otherProducts = []
      this.products.map((item) => {
        products.push({ product_id: item._id, brand_id: item.general.brand_id, is_active: item.is_active ? 1 : 0, order: item.order })
      })
      this.otherProducts.map((item) => {
        otherProducts.push({ product_id: item._id, brand_id: item.general.brand_id, is_active: item.is_active ? 1 : 0, order: item.order })
      })
      const body = { products: products, other_products: otherProducts }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          if (res.msg === 'permission error - products') {
            that.flagVisible.permissionProducts = true
          } else {
            that.$message({ type: 'error', message: res.msg })
          }
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateInstance', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    headerStyle: function () {
      return 'border-width:0;background:#DBE7EA;font-weight:bold;font-size:16px;height:0px;'
    },
    cellStyle: function () {
      return 'border-width:1px 0;'
    },
    selectOrder: function (val, id) {
      const allProducts = _.concat(this.products, this.otherProducts)
      const productIndex = _.findIndex(allProducts, (item) => {
        return item.order === val && item._id !== id
      })
      if (productIndex >= 0) {
        if (productIndex < this.products.length) {
          this.products[productIndex].order = null
        } else {
          this.otherProducts[productIndex - this.products.length].order = null
        }
      }
    },
    toggleSelectMyBrand: function () {
      this.flagToggleMyBrand = !this.flagToggleMyBrand
    },
    toggleSelectOtherBrand: function () {
      this.flagToggleOtherBrands = !this.flagToggleOtherBrands
    },
    toggleProductActive: function (productIndex) {
      this.products[productIndex].is_active = !this.products[productIndex].is_active
    },
    toggleOtherProductActive: function (productIndex) {
      this.otherProducts[productIndex].is_active = !this.otherProducts[productIndex].is_active
    },
    addProductsGuide: function () {
      this.flagVisible.PermissionAddProducts = true
    },
    addMyProducts: function () {
      this.addFromWhere = 'mine'
      this.flagVisible.modalProducts = true
    },
    addOtherProducts: function () {
      if (this.features.other_brands_products.is_enable === 1) {
        this.addFromWhere = 'others'
        this.flagVisible.modalProducts = true
      } else {
        this.flagVisible.permissionOtherProducts = true
      }
    },
    changeProducts: function (params) {
      if (params.tab === 'mine') {
        params.array.map((item) => {
          const indexMyBrand = this.products.findIndex(currentItem => currentItem._id === item._id)
          if (indexMyBrand === -1) {
            this.products = this.products.concat(item)
          }
        })
      } else if (params.tab === 'others') {
        params.array.map((item) => {
          if (item.general.brand_id === this.instance.brand_id) {
            const indexMyBrand2 = this.products.findIndex(currentItem => currentItem._id === item._id)
            if (indexMyBrand2 === -1) {
              this.products = this.products.concat(item)
            }
          } else {
            const indexOtherBrand = this.otherProducts.findIndex(currentItem => currentItem._id === item._id)
            if (indexOtherBrand === -1) {
              this.otherProducts = this.otherProducts.concat(item)
            }
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-table {
  /deep/.el-table__header-wrapper {
    border-radius: 8px;
  }
  /deep/.el-table--border, .el-table--group {
    border: none;
    &::after {
      width: 0px;
    }
  }
}
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .supportButton {
    padding-left: 6px;
    background: white;
    color: black;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}
/deep/.el-dialog__body {
  word-break: normal;
}
.ca-checkbox {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  &.active {
    background: #A5C2CB;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #8BACB4;
  }
  &.inactive {
    background: #F2F2F2;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #E0E0E0;
  }
}
.products-container {
  width: 80%;
  .products-item {
    margin-bottom: 32px;
    .product-header {
      background-color: #DBE7EA;
      border-radius: 8px;
      padding: 12px 16px;
      font-size: 16px;
      .header-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        .info-left {
          width: 65%;
          display: flex;
          align-items: center;
          cursor: pointer;
          .info-icon {
            margin-right: 12px;
          }
          .info-title {
            .title-song {
              font-size: 18px;
              font-weight: bold;
              margin-right: 12px;
            }
          }
        }
        .info-right {
          width: 30%;
          display: flex;
          align-items: center;
          justify-content: space-between;
            .info-support {
              .supportButton {
                padding-top: 2px;
                background: white;
                color: black;
                border-radius: 50%;
                width: 15px;
                height: 15px;
                cursor: pointer;
              }
            }
        }
      }
      .header-titles {
        display: flex;
        .title-item {
          font-weight: bold;
          display: flex;
          align-items: center;
          span {
            margin-right: 5px;
          }
          .text-icon {
            cursor: pointer;
          }
          &.item-price { width: 20%; }
          &.item-name { width: 30%; }
          &.item-active { width: 25%; }
          &.item-order { width: 25%; }
        }
      }
    }
    .product-content {
      .product-list {
        padding: 0 16px;
        .addProductsButton {
          padding-top: 12px;
          border-bottom: solid 1px #F2F2F2;
        }
        .product-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: solid 1px #F2F2F2;
          .item-text {
            &.text-price { width: 20%; }
            &.text-name { width: 30%; }
            &.text-active { width: 25%; }
            &.text-order { width: 25%; }
          }
        }
      }
    }
  }
}
</style>
